var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermanentResident(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8333 61.8333H3.16663M3.16663 27.9167L28.2218 7.875C29.8619 6.56302 31.8997 5.84825 34 5.84825C36.1003 5.84825 38.138 6.56302 39.7781 7.875L64.8333 27.9167M44.7916 10.9583V4.79167C44.7916 4.38279 44.9541 3.99066 45.2432 3.70154C45.5323 3.41243 45.9244 3.25 46.3333 3.25H54.0416C54.4505 3.25 54.8426 3.41243 55.1318 3.70154C55.4209 3.99066 55.5833 4.38279 55.5833 4.79167V20.2083M9.33329 61.8333V23.2917M58.6666 61.8333V23.2917",
    stroke: "#004B6B",
    strokeWidth: 4.625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 61.8333V46.4167C43.25 42.0568 43.25 39.8769 41.8933 38.5233C40.5428 37.1667 38.3629 37.1667 34 37.1667C29.6371 37.1667 27.4602 37.1667 26.1067 38.5233C24.75 39.8738 24.75 42.0537 24.75 46.4167V61.8333M40.1667 23.2917C40.1667 24.9272 39.517 26.4957 38.3605 27.6522C37.204 28.8086 35.6355 29.4583 34 29.4583C32.3645 29.4583 30.796 28.8086 29.6395 27.6522C28.483 26.4957 27.8333 24.9272 27.8333 23.2917C27.8333 21.6562 28.483 20.0877 29.6395 18.9312C30.796 17.7747 32.3645 17.125 34 17.125C35.6355 17.125 37.204 17.7747 38.3605 18.9312C39.517 20.0877 40.1667 21.6562 40.1667 23.2917Z",
    stroke: "#004B6B",
    strokeWidth: 4.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentResident);
export default __webpack_public_path__ + "static/media/permanent-resident.092626db1786d685b9d2a6911799ca04.svg";
export { ForwardRef as ReactComponent };